import api, { adminApiPrefix, apiPrefix } from './Api';
import {
  Slider,
  sliderFromResponse,
  sliderToUpsertRequest,
} from '../interfaces/Slider/Slider';
import {
  SliderDetails,
  sliderDetailsFromResponse,
} from '../interfaces/Slider/SliderDetails';
import {
  SliderSlide,
  sliderSlideFromResponse,
  sliderSlideToUpdateRequest,
} from '../interfaces/Slider/SliderSlide';

const sliderApiPrefix = `${apiPrefix}/sliders`;
const sliderAdminApiPrefix = `${adminApiPrefix}/sliders`;

export const createSlider = async (slider: Slider): Promise<Slider> => {
  const response = await api.post(
    `${sliderAdminApiPrefix}/`,
    sliderToUpsertRequest(slider),
  );

  return sliderFromResponse(response.data?.data);
};

export const createSliderSlide = async (
  sliderID: number,
  image: File,
): Promise<void> => {
  const bodyFormData = new FormData();

  bodyFormData.append('image', image);

  return api.post(`${sliderAdminApiPrefix}/slide/${sliderID}`, bodyFormData);
};

export const getSliders = async (): Promise<Slider[]> => {
  const response = await api.get(`${sliderAdminApiPrefix}/`);

  return (response.data?.data ?? []).map((slider: any) =>
    sliderFromResponse(slider),
  );
};

export const getSliderDetails = async (id: number): Promise<SliderDetails> => {
  const response = await api.get(`${sliderAdminApiPrefix}/${id}`);

  return sliderDetailsFromResponse(response.data);
};

export const getSliderSlides = async (): Promise<SliderSlide[]> => {
  const response = await api.get(sliderApiPrefix);

  return (response.data?.data ?? []).map(sliderSlideFromResponse);
};

export const updateSlider = async (slider: Slider): Promise<Slider> => {
  const response = await api.put(
    `${sliderAdminApiPrefix}/${slider.id}`,
    sliderToUpsertRequest(slider),
  );

  return sliderFromResponse(response.data?.data);
};

export const updateSliderSlide = async (
  sliderSlide: SliderSlide,
): Promise<SliderSlide> => {
  const response = await api.put(
    `${sliderAdminApiPrefix}/slide/${sliderSlide.id}`,
    sliderSlideToUpdateRequest(sliderSlide),
  );

  return sliderSlideFromResponse(response.data?.data);
};

export const deleteSlider = async (id: number): Promise<void> =>
  api.delete(`${sliderAdminApiPrefix}/${id}`);

export const deleteSliderSlide = async (id: number): Promise<void> =>
  api.delete(`${sliderAdminApiPrefix}/slide/${id}`);
